import React from "react";
import CountMatches from "./CountMatches";
import ManageAttributes from "../Attributes/ManageAttributes"
import {connect} from "react-redux";
import {
  SearchModes,
} from "../../store/actions";
import {CaretRight} from '../../icons/icons';

const PreTable = props => {
  return props.render && (
    <div className="product-finder-filters">
      <div className="product-finder-filters__header">
        <button
          onClick={props.onFiltersToggle}
          className={`product-finder-filters__btn ${props.filtersAreOpen ? 'is-open' : ''}`}>
          <span className="product-finder-filters__cta-title">Filter</span>
          <span className="product-finder-filters__icon">
              <CaretRight/>
            </span>
        </button>
        <div className="product-finder-filters__toolbox">
          {props.resultsAvailable &&
            <>
              <div className="product-finder-filters-buttons">
                <ManageAttributes strings={props.strings}/>
                <CountMatches strings={props.strings} contactUsUrl={props.settings.contactUsUrl}/>
              </div>
            </>
          }
          {!props.resultsAvailable &&
            <>
              <CountMatches strings={props.strings} contactUsUrl={props.settings.contactUsUrl}/>
              <div className="product-finder-filters-buttons"/>
            </>
          }

        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    render: !!(state.results.searchExecuted && state.parameters.activeSearchMode !== SearchModes.ALTERNATIVE),
    resultsAvailable: state.results?.count > 0,
  }
};

export default connect(
  mapStateToProps,
)(PreTable)
